import Vue from "vue";
import Router from "vue-router";
import { createRouterLayout } from "vue-router-layout";

Vue.use(Router);

const RouterLayout = createRouterLayout((layout) => {
  return import("@/layouts/" + layout + ".vue");
});

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: RouterLayout,
      children: [
        {
          name: "staking",
          path: "/staking",
          component: () => import("@/pages/staking"),
        },
        // {
        //   name: "steam-staking",
        //   path: "/steam-staking",
        //   component: () => import("@/pages/steam-staking"),
        // },
        // {
        //   name: "limited-sauna-staking",
        //   path: "/limited-sauna-staking",
        //   component: () => import("@/pages/limited-sauna-staking"),
        // },
        {
          name: "cakelp-farming",
          path: "/cakelp-farming",
          component: () => import("@/pages/cakelp-farming"),
        },
        // {
        //   name: "steam-cakelp-farming",
        //   path: "/steam-cakelp-farming",
        //   component: () => import("@/pages/steam-cakelp-farming"),
        // },
        // {
        //   name: "limited-sauna-cakelp-farming",
        //   path: "/limited-sauna-cakelp-farming",
        //   component: () => import("@/pages/limited-sauna-cakelp-farming"),
        // },
        // {
        //   name: "lottery",
        //   path: "/lottery",
        //   component: () => import("@/pages/lottery"),
        // },
        // {
        //   name: "lottery-detail",
        //   path: "/lottery/:type",
        //   component: () => import("@/pages/lottery-detail"),
        // },
        // {
        //   name: "boiler-room",
        //   path: "/boiler-room",
        //   component: () => import("@/pages/boiler-room"),
        // },
        // {
        //   name: "boiler-cakelp-farming",
        //   path: "/boiler-cakelp-farming",
        //   component: () => import("@/pages/boiler-cakelp-farming"),
        // },
        // {
        //   name: "limited-boiler-cakelp-farming",
        //   path: "/limited-boiler-cakelp-farming",
        //   component: () => import("@/pages/limited-boiler-cakelp-farming"),
        // },
      ],
    },
  ],
});
